import { User, Category, Brand, Post, Message } from '../types';

// Mock Users
export const mockUsers: User[] = [
  {
    id: '1',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@email.com',
    joinDate: '2024-01-15',
    isVerified: true,
    sellerStatus: 'verified'
  },
  {
    id: '2',
    firstName: 'Mike',
    lastName: 'Chen',
    email: 'mike.chen@email.com',
    joinDate: '2024-02-20',
    isVerified: true,
    sellerStatus: 'verified'
  },
  {
    id: '3',
    firstName: 'Emma',
    lastName: 'Williams',
    email: 'emma.williams@email.com',
    joinDate: '2024-03-10',
    isVerified: false,
    sellerStatus: 'pending'
  }
];

// Mock Categories
export const mockCategories: Category[] = [
  { id: '1', name: 'Tennis', description: 'Tennis equipment and accessories' },
  { id: '2', name: 'Golf', description: 'Golf clubs, balls, and accessories' },
  { id: '3', name: 'Soccer', description: 'Soccer balls, cleats, and gear' },
  { id: '4', name: 'Basketball', description: 'Basketball shoes, balls, and equipment' },
  { id: '5', name: 'Running', description: 'Running shoes and accessories' },
  { id: '6', name: 'Baseball', description: 'Baseball bats, gloves, and equipment' }
];

// Mock Brands
export const mockBrands: Brand[] = [
  { id: '1', name: 'Wilson', description: 'Premium sports equipment' },
  { id: '2', name: 'Nike', description: 'Athletic wear and shoes' },
  { id: '3', name: 'Adidas', description: 'Sports clothing and footwear' },
  { id: '4', name: 'Callaway', description: 'Golf equipment specialists' },
  { id: '5', name: 'Babolat', description: 'Tennis equipment experts' },
  { id: '6', name: 'Spalding', description: 'Basketball equipment' }
];

// Mock Posts
export const mockPosts: Post[] = [
  {
    id: '1',
    title: 'Wilson Pro Staff Tennis Racket',
    description: 'Excellent condition Wilson Pro Staff racket. Used by professionals. Grip size 4 3/8. Perfect for intermediate to advanced players.',
    price: 189.99,
    condition: 'excellent',
    images: [
      'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=400',
      'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400'
    ],
    categoryId: '1',
    brandId: '1',
    sellerId: '1',
    status: 'active',
    createdAt: '2024-12-01',
    updatedAt: '2024-12-01',
    location: 'San Francisco, CA'
  },
  {
    id: '2',
    title: 'Nike Air Jordan Basketball Shoes',
    description: 'Like-new Nike Air Jordan shoes, size 10.5. Worn only a few times. Perfect for basketball or casual wear.',
    price: 149.99,
    condition: 'like-new',
    images: [
      'https://images.unsplash.com/photo-1584735174965-e1b2530d5e7a?w=400',
      'https://images.unsplash.com/photo-1579952363873-27d3bfad9c0d?w=400'
    ],
    categoryId: '4',
    brandId: '2',
    sellerId: '2',
    status: 'active',
    createdAt: '2024-11-28',
    updatedAt: '2024-11-28',
    location: 'Los Angeles, CA'
  },
  {
    id: '3',
    title: 'Callaway Golf Driver',
    description: 'Callaway Epic Max driver with adjustable loft. Great condition, helps improve distance and accuracy.',
    price: 299.99,
    condition: 'good',
    images: [
      'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=400'
    ],
    categoryId: '2',
    brandId: '4',
    sellerId: '1',
    status: 'active',
    createdAt: '2024-11-25',
    updatedAt: '2024-11-25',
    location: 'San Francisco, CA'
  },
  {
    id: '4',
    title: 'Adidas Soccer Cleats',
    description: 'Professional grade Adidas soccer cleats. Size 9. Excellent grip and comfort for competitive play.',
    price: 89.99,
    condition: 'good',
    images: [
      'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400'
    ],
    categoryId: '3',
    brandId: '3',
    sellerId: '3',
    status: 'active',
    createdAt: '2024-11-20',
    updatedAt: '2024-11-20',
    location: 'Austin, TX'
  },
  {
    id: '5',
    title: 'Spalding Basketball',
    description: 'Official size Spalding basketball. Used but in good condition. Perfect for practice or casual games.',
    price: 25.99,
    condition: 'good',
    images: [
      'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400'
    ],
    categoryId: '4',
    brandId: '6',
    sellerId: '2',
    status: 'active',
    createdAt: '2024-11-18',
    updatedAt: '2024-11-18',
    location: 'Los Angeles, CA'
  },
  {
    id: '6',
    title: 'Nike Running Shoes',
    description: 'Comfortable Nike running shoes, size 8.5. Great for daily runs and training. Minimal wear.',
    price: 79.99,
    condition: 'excellent',
    images: [
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400'
    ],
    categoryId: '5',
    brandId: '2',
    sellerId: '3',
    status: 'active',
    createdAt: '2024-11-15',
    updatedAt: '2024-11-15',
    location: 'Austin, TX'
  }
];

// Mock Messages
export const mockMessages: Message[] = [
  {
    id: '1',
    postId: '1',
    senderId: '2',
    receiverId: '1',
    content: 'Hi! Is this tennis racket still available?',
    timestamp: '2024-12-02T10:30:00Z',
    isRead: false
  },
  {
    id: '2',
    postId: '1',
    senderId: '1',
    receiverId: '2',
    content: 'Yes, it is! Are you interested in purchasing it?',
    timestamp: '2024-12-02T11:00:00Z',
    isRead: true
  },
  {
    id: '3',
    postId: '1',
    senderId: '2',
    receiverId: '1',
    content: 'Definitely! Can we meet somewhere in SF to check it out?',
    timestamp: '2024-12-02T11:15:00Z',
    isRead: false
  }
];

// Helper functions to get related data
export const getUserById = (id: string): User | undefined => 
  mockUsers.find(user => user.id === id);

export const getCategoryById = (id: string): Category | undefined => 
  mockCategories.find(category => category.id === id);

export const getBrandById = (id: string): Brand | undefined => 
  mockBrands.find(brand => brand.id === id);

export const getPostsByCategory = (categoryId: string): Post[] => 
  mockPosts.filter(post => post.categoryId === categoryId);

export const getPostsBySeller = (sellerId: string): Post[] => 
  mockPosts.filter(post => post.sellerId === sellerId);

export const getMessagesByPost = (postId: string): Message[] => 
  mockMessages.filter(message => message.postId === postId);

// Additional helper functions for forms
export const getCategories = async (): Promise<Category[]> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 100));
  return mockCategories;
};

export const getBrands = async (): Promise<Brand[]> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 100));
  return mockBrands;
};

export const getFeaturedPosts = async (): Promise<Post[]> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 200));
  // Return a subset of posts as featured
  return mockPosts.slice(0, 4);
}; 